import {
  PromptRun,
  PromptRunProcessingStatus,
  SegmentRunProcessingStatus,
  Video,
} from '../services/api';
import {
  getRunScopedVideoProjection,
  isDisplayedVideoInProgress,
  isRunProjectionInProgress,
} from './runScopedVideoStatus';

const IN_PROGRESS_STATUSES = new Set([
  'pending',
  'queued',
  'starting',
  'processing',
  'running',
  'in_progress',
  'importing',
  'scanning',
  'uploading',
]);

const normalizeStatus = (status?: string | null): string => {
  if (!status) return '';
  return String(status).trim().toLowerCase();
};

export const isInProgressStatus = (status?: string | null): boolean =>
  IN_PROGRESS_STATUSES.has(normalizeStatus(status));

const hasInProgressSegments = (segments?: SegmentRunProcessingStatus[] | null): boolean => {
  if (!Array.isArray(segments)) return false;
  return segments.some((segment) => isInProgressStatus(segment.status));
};

const hasInProgressRunStatus = (runs?: PromptRunProcessingStatus[] | null): boolean => {
  if (!Array.isArray(runs)) return false;

  return runs.some((run) => {
    if (isRunProjectionInProgress(run)) return true;
    return hasInProgressSegments(run.segments);
  });
};

export const isVideoInProgress = (
  video?: Video | null,
  runScopeId?: string | null,
): boolean => {
  if (!video) return false;
  if (runScopeId) {
    const runProjection = getRunScopedVideoProjection(video, runScopeId);
    if (runProjection) {
      return isRunProjectionInProgress(runProjection);
    }
  }
  if (isDisplayedVideoInProgress(video, runScopeId)) return true;
  return hasInProgressRunStatus(video.processing_status);
};

export const isPromptRunInProgress = (run?: PromptRun | null): boolean => {
  if (!run) return false;
  return isInProgressStatus(run.status);
};
